<template>
  <div>
    <Hero title="Grants" :imageUrl="Image"/>
    <div class="container pb-5">
        <div class="row pt-5 pb-5">
            <div class="col-12">
                <h4 class="pb-4">Call for Grant Applications on the Biological Mechanisms of Fatigue (Phase I)</h4>
                
                <p>
                  This call aims to identify molecular targets for the treatment of fatigue in immune-mediated inflammatory diseases (IMIDs).
                </p>
                
                <p>
                  Fatigue is the most common feature of IMIDs and greatly impacts on quality of life, yet research into its causes has been sorely neglected. Our current understanding of the biological mechanisms remains poor.
                </p>
                
                <p>
                  The Lorna & Yuti Chernajovsky Biomedical Research Foundation is therefore investing an initial £1 million into research projects that will identify molecular mechanisms of fatigue in IMIDs with the aim of developing novel targeted therapies.
                </p>
                
                <p>
                  Successful projects from this initial phase of funding will be eligible for more substantive funding in the second phase.
                </p>
                
                <p>
                  We will fund 5 project grants for 2 years (up to £200,000 each) in this initial phase focussing on discovery of potential targeted therapies for fatigue (including proof of concept).
                </p>
                
                <h4 class="pt-4 pb-3">Who can apply and what you can apply for:</h4>
                
                <ul>
                  <li>The award will be for a maximum £200,000, for up to 24 months with an expected starting date of September 2026.</li>
                  <li>International or national scientific collaborations are essential</li>
                  <li>The lead applicant must be based at a UK research institution with an internationally competitive track record.</li>
                  <li>Risky projects are welcomed.</li>
                  <li>Closing date for submission of applications is Thursday April 2, 2026 at 5 pm.</li>
                  <li>Download application form <a href="./application_form.docx" download>here</a></li>
                  <li>Full applications (in PDF format) should be uploaded to our password-protected Box.com website. Please contact <a href="mailto:yuti@chernajovskyfoundation.org.uk">yuti@chernajovskyfoundation.org.uk</a> to receive your unique access key and password before submission.</li>
                </ul>
                
                <p class="pt-3">
                  <strong>We will not fund social or psychological projects.</strong>
                </p>
            </div>
        </div>
        <div class="row pt-5 pb-5">
            <div class="col-12">
                <p>
                  Grants will be offered to support biomedical research in leading academic institutions, selected following peer review.
                  The Foundation will work with academic institutions and/or charities who support medical research and undertake their own peer review process
                  in accordance with <a href="https://www.amrc.org.uk/principles-of-peer-review" target="_blank">AMRC Guidance</a>.
                </p>
                <p>
                  Please see our current <a href="./foundation_strategy.pdf" target="_blank">Strategy</a>, <a href="./lycbrf_tc_grant.pdf" target="_blank">Grants Terms and Conditions</a>, <a href="./the_use_of_animals_in_research_policy.pdf" target="_blank">Use of Animals</a>,
                  <a href="./data_protection_policy_lycbrf.pdf" target="_blank">Data Protection</a> and <a href="./conflict_of_interest_lycbrf_final.pdf" target="_blank">Conflict of Interest</a> policy documents.
                  We welcome approaches from national charities and academic institutions that qualify. 
                </p>
            </div>
        </div>
        
        <!-- Tabs Navigation -->
        <div class="row pt-5 pb-3">
          <div class="col-12">
            <ul class="nav nav-tabs" id="grantsTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" id="tab-2025" data-toggle="tab" href="#content-2025" role="tab" aria-controls="content-2025" aria-selected="true">2025</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-2024" data-toggle="tab" href="#content-2024" role="tab" aria-controls="content-2024" aria-selected="false">2024</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-2023" data-toggle="tab" href="#content-2023" role="tab" aria-controls="content-2023" aria-selected="false">2023</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-2022" data-toggle="tab" href="#content-2022" role="tab" aria-controls="content-2022" aria-selected="false">2022</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-2021" data-toggle="tab" href="#content-2021" role="tab" aria-controls="content-2021" aria-selected="false">2021</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-2020" data-toggle="tab" href="#content-2020" role="tab" aria-controls="content-2020" aria-selected="false">2020</a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content" id="grantsTabContent">
          <!-- 2025 Tab -->
          <div class="tab-pane fade show active" id="content-2025" role="tabpanel" aria-labelledby="tab-2025">
            <div id="grants2025" class="row pb-5 pt-5">
              <div class="col-12">
                <h4 class="text-center">Grants awarded 2025</h4>
              </div>
          <div class="col-12 pt-5">
            <div class="accordion" id="accordionYlc2025">
              <!-- Card 2025-1 -->
              <div class="card">
                <div class="card-header" id="heading2025One">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapse2025One" aria-expanded="false" aria-controls="collapse2025One">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            4-year PhD Studentship: Targeted CRISPR screens to understand the biology of the Cryptosporidium crystalloid body
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead Applicant:</div>
                          <div class="fs10">Dr Adam Sateriale</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">The Francis Crick Institute</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£237,875</div>
                        </div>
                    </button>
                </div>
                <div id="collapse2025One" class="collapse" aria-labelledby="heading2025One" data-parent="#accordionYlc2025">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      The Cryptosporidium parasite is a major cause of diarrhea worldwide. Children disproportionally bear the burden of morbidity and mortality associated with this disease, and although this parasite is a major threat to public health, there are no vaccines or effective treatments available. During its replication cycle, Cryptosporidium creates a unique organelle known as the 'crystalloid body', named for its crystal lattice-like appearance. The function of this organelle is unknown, however, in closely related parasites such as Plasmodium (the causative agent of malaria) this organelle is essential for parasite survival and transmission of infection. Because of this, the crystalloid body is an attractive target for therapeutic intervention. In this project, the student will use the CRISPR screening technology to identify the essential core components of the Cryptosporidium crystalloid body. They will then study how the loss of the crystalloid body affects parasite survival and disease pathogenesis.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> 
            </div>
          </div>
          <!-- 2024 Tab -->
          <div class="tab-pane fade" id="content-2024" role="tabpanel" aria-labelledby="tab-2024">
            <div id="grants2024" class="row pb-5 pt-5">
              <div class="col-12">
                <h4 class="text-center">Grants awarded in 2024</h4>
              </div>
          <div class="col-12 pt-5">
            <div class="accordion" id="accordionYlc2024">
              <!-- Card 2024-1 -->
              <div class="card">
                <div class="card-header" id="heading2024One">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapse2024One" aria-expanded="false" aria-controls="collapse2024One">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Unveiling the mysteries of the Sympathetic Nervous System (SNS): Engineering a 3-D model for the study of SNS functions in health and disease
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Post-doctoral fellowship</div>
                          <div class="fs10">Dr Kathryn Frost</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">Instituto de Investigaçao e Innovaçao em Saúde, Portugal</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">€114,200</div>
                        </div>
                    </button>
                </div>
                <div id="collapse2024One" class="collapse" aria-labelledby="heading2024One" data-parent="#accordionYlc2024">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      A post-doctoral fellowship has been awarded to Dr Kathryn Frost, who previously was a PhD student. It is aimed to provide valuable time abroad to enable her to develop independent studies in centres of excellence. She will study the SNS, which has been implicated in many diseases including cancer metastasis. Our understanding of this complex interaction is limited by the lack of in vitro multi-cellular models of the human SNS. This project will address this gap by developing a 3D in vitro model using human induced pluripotent stem cells (hIPSCs) and a biocompatible hydrogel matrix to mimic the extracellular matrix of the sympathetic ganglion. This innovative setup is intended to be a reproducible model that will be used to study the interactions between SNS cells and the bone metastatic niche thus enabling the identification of potential targets for therapeutic interventions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> 
            </div>
          </div>
          <!-- 2023 Tab -->
          <div class="tab-pane fade" id="content-2023" role="tabpanel" aria-labelledby="tab-2023">
            <div id="grants2023" class="row pb-5 pt-5">
              <div class="col-12">
                <h4 class="text-center">Grants awarded in 2023</h4>
              </div>
          <div class="col-12 pt-5">
            <div class="accordion" id="accordionYlc2023">
              <!-- Card 2023-1 -->
              <div class="card">
                <div class="card-header" id="heading2023One">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapse2023One" aria-expanded="false" aria-controls="collapse2023One">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Targeting TfH cells across multiple autoimmune diseases
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead Applicant:</div>
                          <div class="fs10">Professor Lucy Walker</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University College London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£500,000</div>
                        </div>
                    </button>
                </div>
                <div id="collapse2023One" class="collapse" aria-labelledby="heading2023One" data-parent="#accordionYlc2023">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Professor Lucy Walker has been awarded a Phase II grant to develop further her work on T follicular helper (TfH) cells. TfH cells are seen early on in autoimmune conditions including type I diabetes, rheumatoid arthritis, lupus and multiple sclerosis. Data from animal models suggests that TfH may be important in causing disease. Early involvement of TfH may be common ground between autoimmune diseases despite their different symptoms. She proposes a novel strategy to target TfH cells delivering a toxic drug to deplete them. This project will develop, optimise and test this new therapy.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card 2023-2 -->
              <div class="card">
                <div class="card-header" id="heading2023Two">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapse2023Two" aria-expanded="false" aria-controls="collapse2023Two">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Drug Development of novel ACTH-based peptides
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead Applicant:</div>
                          <div class="fs10">Dr Trinidad Montero-Melendez</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">Queen Mary, University of London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£493,277</div>
                        </div>
                    </button>
                </div>
                <div id="collapse2023Two" class="collapse" aria-labelledby="heading2023Two" data-parent="#accordionYlc2023">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      The adrenocorticotropin hormone (ACTH) can be used to treat several autoimmune diseases including rheumatoid arthritis and multiple sclerosis, although its use is very limited because ACTH also activates the stress hormone cortisol, causing serious side effects. In this Phase II project they aim to design new drugs by modifying ACTH so that they don't activate cortisol release, while maintaining their clinical efficacy on multiple autoimmune diseases.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> 
            </div>
          </div>
          <!-- 2022 Tab -->
          <div class="tab-pane fade" id="content-2022" role="tabpanel" aria-labelledby="tab-2022">
            <div id="grants2022" class="row pb-5 pt-5">
              <div class="col-12">
                <h4 class="text-center">Grants awarded in 2022</h4>
            <p class="pt-4">
              The Chernajovsky Foundation is delighted to announce the funding of 10 new research<br>
              projects addressing the root cause of autoimmune disease.
            </p>
            <p>
              We are partnering with Connect Immune Research* to invest nearly £1 million in new grants<br>
              <b>‘Targeting shared mechanisms in immune-mediated inflammatory diseases.’</b>
            </p>
            <p>
              <b>*Connect Immune Research</b> is a partnership of charities who are dedicated to tackling autoimmune conditions. Members include the type 1 diabetes charity <a href="https://jdrf.org.uk/" target="_blank">JDRF</a>, <a href="https://www.versusarthritis.org/" target="_blank">Versus Arthritis</a>, <a href="https://www.mssociety.org.uk/" target="_blank">MS Society</a>, <a href="https://www.immunology.org/" target="_blank">British Society for Immunology</a>, <a href="https://www.alopecia.org.uk/" target="_blank">Alopecia UK</a>, <a href="https://www.coeliac.org.uk/home/" target="_blank">Coeliac UK</a>, <a href="https://www.papaa.org/" target="_blank">Psoriasis and Psoriatic Arthritis Alliance</a> and <a href="https://www.bowelresearchuk.org/" target="_blank">Bowel Research UK</a>. 
            </p>
          </div>
          <div class="col-12 pt-5">
            <div class="accordion" id="accordionYlcA">
              <!-- Card no.1A -->
              <div class="card">
                <div class="card-header" id="headingOneA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseOneA" aria-expanded="false" aria-controls="collapseOneA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Applying functional genomics to identify causal cell states across autoimmune diseases
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Dr Kate Attfield</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University of Oxford</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£99,645</div>
                        </div>
                    </button>
                </div>
                <div id="collapseOneA" class="collapse" aria-labelledby="headingOne" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      The immune system is a complex network of interacting cell types that are constantly and rapidly changing and reacting to their surroundings, ensuring a robust and rapid response to potential harm.<br> In individuals who are genetically vulnerable, these same processes can also lead to the development of numerous autoimmune diseases, yet how or why this occurs remains unknown.
                    </p>
                    <p>
                      Using genetic information already generated from thousands of people across multiple autoimmune diseases, this project aims to expose how individual immune cells can be driven to cause disease and how new treatments may be developed to redirect their fate. Specifically, this project focuses on multiple sclerosis and inflammatory bowel disease, using clinical samples from affected tissues and peripheral blood. The identification of cells that are causal (i.e., are actively using regions of their DNA that are associated with disease risk) will be achieved using a broad range of technologies and analytical methods.                   
                    </p>
                    <p>
                      Together, these findings aim to contribute to the development of better diagnostic tools and drug design for genetically-associated autoimmune diseases, with a key focus on exclusively eliminating or redirecting only those cells or pathways that are causal.                    
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.2A -->
              <div class="card">
                <div class="card-header" id="headingTwoA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseTwoA" aria-expanded="false" aria-controls="collapseTwoA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Chimaeric auto-antigen receptor immunotherapy for antiphospholipid syndrome                   
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Professor Anastasios Karadimitris</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">Imperial College London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£90,000</div>
                        </div>
                    </button>
                </div>
                <div id="collapseTwoA" class="collapse" aria-labelledby="headingTwoA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Antiphospholipid syndrome is an autoimmune condition where the body produces abnormal antibodies called antiphospholipid antibodies that predispose patients to an increased risk of blood clots. This can lead to a number of serious conditions including stroke, heart attack, pulmonary embolism or deep vein thrombosis. Current treatments are limited to long-term anticoagulation medicines that thin the blood rather than therapies that target the disease-causing antiphospholipid antibodies themselves.                    
                    </p>
                    <p>
                      This project aims to precisely identify the immune cells that are the source of the antiphospholipid antibodies in this disease and selectively eliminate them using a new approach called chimaeric auto-antigen receptor (CAAR) immunotherapy. In this one-year project, the team expect to provide in the laboratory proof-of-principle that this approach is feasible and could be effective in treating antiphospholipid syndrome. This would be the first step towards further pre-clinical development of CAAR-T immunotherapy before it is tested in patients with antiphospholipid syndrome in the future.                    
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Card no.3A -->
              <div class="card">
                <div class="card-header" id="headingThreeA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseThreeA" aria-expanded="false" aria-controls="collapseThreeA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Development of safer ACTH-based drugs for autoimmune diseases
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Dr Trinidad Montero-Melendez</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">Queen Mary University of London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£72,633</div>
                        </div>
                    </button>
                </div>
                <div id="collapseThreeA" class="collapse" aria-labelledby="headingThreeA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Steroids are commonly used to treat autoimmune conditions, such as rheumatoid arthritis, multiple sclerosis and lupus, due to their ability to suppress the immune system. Their use is limited to treat only acute flares of the disease, as they can trigger serious side effects in some people. This can impede their long-term use in chronic conditions which require life-long treatments.
                    </p>
                    <p>
                      Adrenocorticotropin hormone (ACTH) is a hormone and is well known for its anti-inflammatory effects. These effects are caused in part due to ACTH’s role in the release of another hormone called cortisol by activating the adrenal glands, and also via activating a separate pathway on immune cells in the inflamed tissues. 
                    </p>
                    <p>
                      This project aims to build our knowledge of the properties of several new potential anti-inflammatory drugs, whose design is based on adrenocorticotropin (ACTH) hormone. The scientists aim to assess if any of these new drugs have the potential to produce the same effectiveness as current steroid treatments in chronic autoimmune diseases but without the side effects.
                    </p>
                  </div>
                </div>
              </div> 
              <!-- Card no.4A -->
              <div class="card">
                <div class="card-header" id="headingFourA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseFourA" aria-expanded="false" aria-controls="collapseFourA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Intestinal permeability – a new target for autoimmune diseases prevention and therapy
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Professor Claudia Mauri</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University College London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£100,000</div>
                        </div>
                    </button>
                </div>
                <div id="collapseFourA" class="collapse" aria-labelledby="headingFourA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Autoimmunity occurs when the cells of our own immune system attack our tissues and organs. Although these diseases tend to be studied separately, it is not uncommon that people with one autoimmune disorder develop a second autoimmune disease. This may be partly due to shared genes; however, findings showing that only one of two genetically identical twins may develop autoimmunity challenges this idea. Genetics do not explain the whole story of how autoimmunity is initiated and there must be other environmental triggers for disease.
                    </p>
                    <p>
                      This project will establish whether changes in the gut are integral part of several autoimmune diseases including rheumatoid arthritis, multiple sclerosis, and lupus. This project aims to assess whether people living with autoimmunity could benefit from the use of new therapies aimed at restoring balance in the gut. The researchers hope that their findings will change the way that we view organ-specific autoimmune diseases by including the clinical evaluation of gut-markers that are not routinely included in the current management of these diseases.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.5A -->
              <div class="card">
                <div class="card-header" id="headingFiveA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseFiveA" aria-expanded="false" aria-controls="collapseFiveA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Measuring immunocompetence by assessment of torque teno virus levels in autoimmune diseases following initiation of immunosuppression
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Dr Andreas Kronbichler</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University of Cambridge</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£99,930</div>
                        </div>
                    </button>
                </div>
                <div id="collapseFiveA" class="collapse" aria-labelledby="headingFiveA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Treatments that suppress the immune system are used to control disease activity in autoimmune disorders, but come with the issue that treatments can lead to side effects such as infections. This project aims to characterise a person’s ‘immunocompetence’ and their ability to maintain a functioning immune system capable of responding to and clearing infections, while also having no or minimal autoimmune disease activity. There are currently no markers, either disease characteristics or laboratory tests, to predict a ‘normal immunocompetence’ across different autoimmune disorders. A virus, which is unable to cause any disease, called the torque teno virus has been used in transplant medicine as a marker to predict how well a patient’s immune system is functioning. If the patient has low levels of virus, they are at risk of organ rejection whereas if they have high levels of the virus, they are at risk of falling sick with an infectious disease. This project will test whether this technique can be transferred to monitoring immunocompetence in people with autoimmune conditions.
                    </p>
                    <p>
                      This project aims to test the use of torque teno virus as a monitoring tool in two autoimmune diseases – anti-neutrophil cytoplasm antibody-associated vasculitis and systemic lupus erythematosus with a focus on kidney involvement. If levels of torque teno virus in patients proves to be a successful monitoring tool, it could one day help with the care of patients with autoimmune disorders by becoming a part of routine laboratory investigations.
                    </p>
                  </div>
                </div>
                <!-- Card no.6A -->
              <div class="card">
                <div class="card-header" id="headingSixA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseSixA" aria-expanded="false" aria-controls="collapseSixA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Mitochondrial dysfunction as a therapeutic target upstream of interferon type 1 in rheumatic disease
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Dr Meredyth Wilkinson</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">UCL Great Ormond Street Institute of Child Health</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£98,719</div>
                        </div>
                    </button>
                </div>
                <div id="collapseSixA" class="collapse" aria-labelledby="headingSixA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Juvenile dermatomyositis is a rare autoimmune condition in which the body’s immune system attacks the muscles and skin leading to muscle weakness and skin rashes. Treatments used in juvenile dermatomyositis suppress the body’s immune system. However, these medications do not work for all patients and can cause some unwanted side effects. The researchers have examined genes (the human code) and the pattern of expression of these genes in immune cells from patients with juvenile dermatomyositis.
                    </p>
                    <p>
                      They discovered that genes that code for mitochondria (the ‘powerhouse’ energy producers of the cell) are less active in these patients, even those already on strong treatment, compared with healthy children of the same age. The project will examine this finding in more detail and progress this discovery to look for new and very specific drugs to improve the treatment of juvenile dermatomyositis and other autoimmune conditions such as juvenile systemic lupus erythematous and adult dermatomyositis. If successful, these findings could be rapidly translated to clinical trials since some of the drugs under investigation are already licenced.
                    </p>
                  </div>
                </div>
              </div>
              </div>
              <!-- Card no.7A -->
              <div class="card">
                <div class="card-header" id="headingSevenA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseSevenA" aria-expanded="false" aria-controls="collapseSevenA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Neutrophil extracellular traps (NETs) as a therapeutic target for the treatment of autoimmune inflammatory disease
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Dr Helen Wright</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University of Liverpool</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£82,971</div>
                        </div>
                    </button>
                </div>
                <div id="collapseSevenA" class="collapse" aria-labelledby="headingSevenA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Neutrophils are a type of white blood cell that protect us against infection. However, inappropriate activation of neutrophils, for example in autoimmune diseases such as rheumatoid arthritis and lupus, can cause them to release toxic molecules that they usually use to kill microbes directly onto the surface of our own tissues. This causes damage to small blood vessels in organs such as the kidney and the surface of our joints (cartilage). During certain types of inflammation, neutrophils can dismantle their DNA (genetic code) and release it outside the cell as ‘mesh’ or ‘net’. This is called a neutrophil extracellular trap or NET. NETs are covered in molecules that trap and kill bacteria, and so are an essential process that protects us from infection.
                    </p>
                    <p>
                      However, in autoimmune diseases the NETs can cause the body to mis-recognise some molecules as ‘foreign’, and so create an inappropriate immune response (auto-antibodies) against the tissues that contain high levels of these molecules. We believe that NETs may therefore be a new drug target for treatment of autoimmune inflammatory diseases.  This project will identify key targets for drug development to target NET production in inflammatory diseases, including rheumatoid arthritis and lupus. It is hoped this work will be a step towards increased treatment options and improved disease outcomes for patients with autoimmune diseases.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.8A -->
              <div class="card">
                <div class="card-header" id="headingEightA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseEightA" aria-expanded="false" aria-controls="collapseEightA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Targeting follicular helper T cells across multiple autoimmune diseases
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Professor Lucy Walker</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University College London</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£99,439</div>
                        </div>
                    </button>
                </div>
                <div id="collapseEightA" class="collapse" aria-labelledby="headingEightA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      The common ground between different autoimmune conditions tends to lie early in disease development, when the immune system stops being properly controlled. This ‘loss of immune tolerance’ allows immune responses to develop against our own body, leading ultimately to tissue damage and symptom development. This project aims to nip this process in the bud, by preventing the early interactions between two types of immune cells called T cells and B cells. It may therefore be particularly relevant to people at the early stages of autoimmune disease development, i.e. people who are recently diagnosed, or possibly even people who are at risk of disease development.
                    </p>
                    <p>
                      By targeting the mechanisms that underlie disease development, rather than just the symptoms, this approach may offer a way to stop autoimmune diseases in their tracks. The project brings together two disciplines, immunology and organic chemistry, to develop a novel approach to selectively target follicular helper T cells, a type of immune cell implicated in the development of multiple autoimmune diseases. This could ultimately form the basis for a new therapy for people in the early stages of autoimmune disease development or those at high risk.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.9A -->
              <div class="card">
                <div class="card-header" id="headingNineA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseNineA" aria-expanded="false" aria-controls="collapseNineA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              Targeting pathogenic fibroblasts in immune mediated inflammatory disease                            
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Professor Adam Croft</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University of Birmingham</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£99,886</div>
                        </div>
                    </button>
                </div>
                <div id="collapseNineA" class="collapse" aria-labelledby="headingNineA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      Rheumatoid arthritis and Sjögren's syndrome are both autoimmune diseases where the body’s immune cells attack its own tissues. The researchers have previously identified a subset of a cell type called fibroblasts which seem linked to the disease. It is found in the joints of patients with active rheumatoid arthritis despite treatment, and in patients with active Sjögren's syndrome. These fibroblasts can affect the functioning of the immune system by producing high levels of a protein called fibroblast activation protein-α. The long-term goal of this project is to develop a new strategy to specifically target these fibroblast cells in patients with rheumatoid arthritis and Sjögren's syndrome using a new immunotherapy approach.                    </p>
                    <p>
                      If successful, the researchers hope that this will result in a new approach for treating these conditions that leads to long-term reduction of inflammation and prevents joint tissue damage. This will also open the possibility of targeting novel disease pathways in patients who have exhausted currently available treatment options.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.10A -->
              <div class="card">
                <div class="card-header" id="headingTenA">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseTenA" aria-expanded="false" aria-controls="collapseTenA">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                              The use of PEPITEM and its novel peptide-mimetics for the treatment of autoimmune and chronic inflammatory diseases
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Lead applicant:</div>
                          <div class="fs10">Professor Ed Rainger</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">University of Birmingham</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£99,158</div>
                        </div>
                    </button>
                </div>
                <div id="collapseTenA" class="collapse" aria-labelledby="headingTenA" data-parent="#accordionYlcA">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <p>
                      The aim of this research is to improve the outcome for patients diagnosed with autoimmune conditions such as rheumatoid arthritis or psoriasis and ultimately help to cure these diseases. Current treatments target the processes that cause the symptoms of autoimmune conditions but fail to effectively cure disease. 
                    </p>
                    <p>
                      This project’s strategy is to target a pathway, which naturally limits immune cells getting into the tissues in healthy individuals. This pathway doesn’t always function correctly in people with autoimmune diseases, leading to an exaggerated inflammatory response. In the longer-term, the researchers aim to develop a drug based on a molecule called PEPITEM that can restore the function of the pathway in patients. The findings aim to provide a new approach to the clinical management of rheumatoid arthritis, psoriasis and other immune-mediated inflammatory diseases, allowing personalised medicine based on restoring the function of this pathway.
                    </p>
                  </div>
                </div>
              </div>
          </div> 
            </div>
          </div>
          <!-- 2021 Tab -->
          <div class="tab-pane fade" id="content-2021" role="tabpanel" aria-labelledby="tab-2021">
            <div class="container pt-5 pb-5 mb-5">
              <div class="row">
                <div class="col-12">
                  <h4 class="text-center pb-4">Prizes awarded 2021</h4>
          <p>The Chernajovsky Foundation funded prizes for a total of £ 1000 to three delegates for their presentations at the inaugural Birmingham Inflammation, Repair and Ageing conference held virtually on July 1st and 2nd 2021.</p>
          <p>
          Two prizes were awarded for the 5 minutes flash talks: Dr Kylie Belchamber, a postdoctoral fellow at Birmingham University, for her work on compromised neutrophil function in COVID-19 and Letizia Marchetti, a PhD student at Newcastle University, for her research on the role of hepatic NFkB1 in age-related inflammation. </p>
          <p>A third prize was for the best elevated short talk and this was awarded to Dr Nikhil Jain, a postdoctoral fellow at ETH Zurich, for his research on the mechanobiology of macrophage in inflammation.
          </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 2020 Tab -->
          <div class="tab-pane fade" id="content-2020" role="tabpanel" aria-labelledby="tab-2020">
            <div class="row pt-5">
              <div class="col-12">
                <h4 class="text-center">Grants awarded in 2020</h4>
            <p class="pt-4 pb-3">PhD studentships provide the training ground for young scientists who will drive research forward in future years.</p>
          </div>
          <div class="col-12">
            <div class="accordion" id="accordionYlc">
              <!-- Card no.1 -->
              <div class="card">
                <div class="card-header" id="headingOne">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Rational design of poxvirus vectors to maximise immune responses
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Supervisors:</div>
                          <div class="fs10">Dr Carlos Maluquer de Motes and Dr Jorge Gutierrez</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-yellow">
                          <div>Location:</div>
                          <div class="fs10">Surrey University</div>
                        </div>
                        <div class="col-12 col-md-6 border-left-blue mt-3">
                          <div>Cost:</div>
                          <div class="fs10">£83,500</div>
                        </div>
                    </button>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 3 years</div>
                    <div>Start date: Autumn 2020</div>
                    <br>
                    <div class="font-weight-bold">Why study this?</div>
                    <p>
                    Vaccination is a powerful tool to eradicate infectious diseases saving millions of lives worldwide. However, for many infections there isn’t an effective vaccine. Modern vaccines now use the backbone of Pox virus adding to it a gene to code for a target (or more than one target) of the infectious agent.
                    Recently, it was found that a component of the Pox virus dampens the immune responses of the host. Removing this gene should increase immunity and therefore effectiveness of the vaccine.
                    </p>
                    <div class="font-weight-bold">
                    What will the student be doing? </div>
                    <p>
                    The student will remove unwanted components of the pox virus, and will also add new components to amplify the immune response to the vaccine. These will be tested in human cells in the laboratory.
                    </p>
                    <div class="font-weight-bold">What do they expect to achieve?</div>
                    <p>
                    They expect to demonstrate that their modifications can improve immune responses to vaccines.
                    </p>
                    <div class="font-weight-bold">What could be the impact?</div>
                    <p>
                      This work could lead to new designs of vaccines that make them more effective. 
                    </p>

                  </div>
                </div>
              </div>
              <!-- Card no.2 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Modification of blood coagulation factor to retarget adenovirus for gene therapy
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Professor John Mc Vey and Professor Hardev Pandha</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">Surrey University</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£95,981</div>
                      </div>
                    </button>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                  <div>Duration: 3 years</div>
                  <div>Start date: Autumn 2020</div>
                  <br>
                  <div class="font-weight-bold">
                  Why study this? </div>
                  <p>
                  Gene therapy is a way of introducing genes into the body.  It can be used to correct a gene deficiency, or to introduce a gene of a protein that can act as a medicine.  
                  </p>
                  <p>
                  Adenovirus 5 is used widely for gene therapy but tends to concentrate in the liver because it interacts with a coagulation factor.  Previous attempts at changing the adenovirus have not worked. Therefore, scientists are turning their attention to the coagulation factor. 
                  </p>
                  <div class="font-weight-bold">
                  What will the student be doing? </div>
                  <p>
                  The student will create a range of variants of the coagulation factor and then select those that bind strongly to the virus but block the binding to the liver.  They will also be attaching these molecules to an antibody fragment that will allow retargeting of the gene therapy to specific organs. 
                  </p>
                  <div class="font-weight-bold">
                  What do they expect to achieve? </div>
                  <p>
                  They expect to find a molecule that will prevent the gene therapy from accumulating in the liver and produce new molecules that target it to parts of the body where it is most needed. </p>
                  <div class="font-weight-bold">
                  What could be the impact? </div>
                  <p>
                  Improving gene therapy will allow the delivery of many new treatments to a wide range of conditions.
                  </p>
                  </div>
                </div>
              </div>
              <!-- Card no.3 -->
              <div class="card">
                <div class="card-header" id="headingThree">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Modulating the brain immune response to protect against progressive multi-focal leukoencephalopathy (PML)
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Dr Marieke Pingen and Professor Chris Linnington</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">University of Glasgow</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£106,764</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow mt-3">
                        <div>Partner:</div>
                        <div class="fs10">The Multiple Sclerosis Society</div>
                      </div>
                    </button>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 3 years</div>
                    <div>Start date: Autumn 2020</div>
                    <br>
                    <div class="font-weight-bold">Why study this? </div>
                    <p>A small number of people with multiple sclerosis (MS) treated with the drug Natalizumab can develop a disease called Progressive Multi-focal Leukoencephalopathy. This is caused by an infection of the brain by the JCV virus. This is a serious disease that can be fatal. </p>
                    <div class="font-weight-bold">
                    What will the student be doing? </div>
                    <p>
                    An antibody has been shown to inhibit JCV in cultures and inhibit viral spread in mice. The student will characterise the soluble mediator that is produced in brain cell cultures treated with this antibody and test their capabilities to inhibit JCV.
                    </p>
                    <div class="font-weight-bold">
                    What do they expect to achieve? </div>
                    <p>
                    They expect to find new molecules that inhibit JCV infection in brain cell cultures that can be used as a new treatment for JCV infection in MS.
                    </p>
                    <div class="font-weight-bold">
                    What could be the impact? </div>
                    <p>
                    A new therapy that could be given to people with MS taking Natalizumab to prevent JCV infection.
                    </p>

                  </div>
                </div>
              </div>
              <!-- Card no.4 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseTwo">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            The ageing bone - PEPITEM as a novel inducer of bone repair
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Dr Helen McGettrick and Dr James Edwards</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">Universities of Birmingham and Oxford</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£143,790.25</div>
                      </div>
                       <div class="col-12 col-md-6 border-left-yellow mt-3">
                        <div>Partner:</div>
                        <div class="fs10">British Society for Research on Ageing</div>
                      </div>
                    </button>
                </div>
                <div id="collapseFour" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 3 years</div>
                    <div>Start date: Autumn 2020 </div>
                    <br>
                    <div class="font-weight-bold">
                    Why study this? </div>
                    <p>
                    Osteoporosis is the thinning of the bones that occurs as we age and results in brittle, broken bones. There is no cure for osteoporosis and current therapies focus on preventing bone erosion, rather than repair.  Broken bones in older people can be serious, especially hip fractures, which often lead to loss of independence and can lead to death. 
                    </p>
                    <div class="font-weight-bold">
                    What will the student be doing? </div>
                    <p>
                    The researchers have previously discovered a protein called PEPITEM that can induce bone formation. The student will study how PEPITEM works to increase bone growth in both bone cell cultures and after injury, ageing and osteoporosis.
                    </p>
                    <div class="font-weight-bold">
                    What do they expect to achieve? </div>
                    <p>
                    It s expected that these studies will provide an understanding of the mechanisms of action of PEPITEM in different circumstances of bone disease. </p>
                    <div class="font-weight-bold">
                    What could be the impact? </div>
                    <p>
                    These studies are preliminary to the development of a new drug for the treatment of osteoporosis and broken bones.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.5 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseTwo">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Targeting the STING-mediated DNA-sensing pathway to suppress Autoimmunity and Inflammation-Ageing
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Dr Heather Wilson, Prof Endre Kiss-Toth, Prof Ilaria Bellantuono and Dr Gareth Richards</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">Sheffield University</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£98,138</div>
                      </div>
                    </button>
                </div>
                <div id="collapseFive" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 3½ years</div>
                    <div>Start date: Autumn 2020 </div>
                    <br>
                    <div class="font-weight-bold">
                    Why study this? </div>
                    <p>
                    Damage to DNA occurs in both ageing and autoimmune diseases. A protein called STING is able to sense if DNA has been damaged. If damage has occurred, STING causes the cell to produce inflammatory molecules known as cytokines. This uncontrolled inflammation can cause a great deal of tissue damage.
                    </p>
                    <p>
                    There is another protein that interacts with STING making the inflammation stronger. But when this other protein is blocked, STING no longer induces cytokine secretion thus reducing inflammation. 
                    </p>
                    <div class="font-weight-bold">
                    What will the student be doing? </div>
                    <p>
                    The student will be trying to find small molecules that can stop the interaction between STING and its partner protein.  They will see whether small molecules can reduce inflammation when tested in the laboratory on old cells or cells from people with autoimmune disease.
                    </p>
                    <div class="font-weight-bold">
                    What do they expect to achieve? 
                    </div>
                    <p>
                    They hope to be able to identify a number of small molecules that can block inflammation and can be taken forward to develop into a new therapy for autoimmunity and in age-related disease.
                    </p>
                    <div class="font-weight-bold">
                    What could be the impact? </div>
                    <p>
                    The development of new drugs to dampen inflammation could provide help to people with autoimmune diseases and age-related diseases.
                    </p>

                  </div>
                </div>
              </div>
              <!-- Card no.6 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseTwo">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            Establishing a rationale for FGF23 modulation as a therapy in the critically ill patient
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Dr Dhruv Parekh, Dr Aaron Scott and Professor David Thicket</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">Birmingham University</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£142,908.50</div>
                      </div>
                    </button>
                </div>
                <div id="collapseSix" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 4 years</div>
                    <div>Start date: Autumn 2020 </div>
                    <br>
                    <div class="font-weight-bold">
                    Why study this? </div>
                    <p>
                    Sepsis is the body’s overwhelming and life-threatening response to infection that can lead to tissue damage, organ failure, and death. In other words, it’s your body’s overactive and toxic response to an infection and a common cause of people being admitted into Intensive Care Units. 
                    </p>
                    <p>
                    FGF23 is a molecule that is involved in immunity and vitamin D metabolism and its levels are high in patients with sepsis. The levels of FGF23 are also associated with how ill people are, and likelihood of dying.    
                    </p>
                    <div class="font-weight-bold">
                    What will the student be doing? </div>
                    <p>
                    The student will be characterising the role of FGF23 in sepsis in cultures of cells in the laboratory and determining whether it has a driving role in sepsis. The student will also be seeing whether blocking FGF23 with a monoclonal antibody can reduce inflammation in an animal model of sepsis. 
                    </p>
                    <div class="font-weight-bold">
                    What do they expect to achieve? </div>
                    <p>
                    The studies will determine whether FGF23 is a key target for the treatment of sepsis, and see whether blocking it with an antibody can be a potential therapy.
                    </p>
                    <div class="font-weight-bold">
                    What could be the impact? </div>
                    <p>
                    The project may lead to a new treatment to improve the outcomes for seriously ill people with sepsis. 
                    </p>
                  </div>
                </div>
              </div>
              <!-- Card no.7 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                    <button type="button" class="row fs12 fs-sm-10 mr-0 ml-0 collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseTwo">
                      <div class="d-flex justify-content-between card-title col-12 pl-0 pb-1 mb-4 font-weight-bold" style="border-bottom: 0.5px solid #ADDDDE;">
                            <div class="pr-3">
                            New therapeutic targets for treating the failing heart in arthritis
                            </div>
                            <span class="fas fa-plus fs16 text-blue"></span>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Supervisors:</div>
                        <div class="fs10">Professor Mauro Perretti and Dr Dianne Cooper </div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow">
                        <div>Location:</div>
                        <div class="fs10">William Harvey Research Institute, Queen Mary University of London</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-blue mt-3">
                        <div>Cost:</div>
                        <div class="fs10">£94,008</div>
                      </div>
                      <div class="col-12 col-md-6 border-left-yellow mt-3">
                        <div>Partner:</div>
                        <div class="fs10">William Harvey Research Foundation</div>
                      </div>
                    </button>
                </div>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionYlc">
                  <div class="card-body fs12 fs-sm-10 bg-light-gray mb-3">
                    <div>Duration: 3 years</div>
                    <div>Start date: Autumn 2020</div>
                    <br>
                    <div class="font-weight-bold">
                    Why study this?
                    </div>
                    <p>
                    People with rheumatoid arthritis have an increased risk of dying due to heart failure. They are particularly susceptible to a type of heart failure where the heart does not relax and refill properly after each beat.  It is unclear whether the current successful treatments for alleviating joint problems also reduces the risk of developing heart failure. 
                    </p>

                    <div class="font-weight-bold">What will the student be doing? </div>
                    <p>
                    The student will identify the link between the systemic inflammation that arises as a result of rheumatoid arthritis and alterations in cardiac structure and function that lead to heart failure. The student will be using a newly developed arthritis model with similar heart failure features as those seen in humans to assess the effects of anti-inflammatory biological therapies on the heart at different stages of disease development and identify new targets for treatment through genetic screening. 
                    </p>
                    <div class="font-weight-bold">
                    What do they expect to achieve? </div>
                    <p>
                    Heart disease in rheumatoid arthritis has not been a major focus of research in the past, but this study should identify whether heart failure can be prevented by existing treatments, as well as identifying potential new targets for drug development. 
                    </p>
                    <div class="font-weight-bold">
                    What could be the impact? </div>
                    <p>
                    Identifying existing treatments that can help heart disease in rheumatoid arthritis would provide an immediate help for people with rheumatoid arthritis.  New targets could open avenues for future treatments specific for the heart failure seen in rheumatoid arthritis.   
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
            </div>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import Image from '../assets/grants.jpg';
import Hero from './Hero.vue'

export default {
  name: 'app',
  components: {
    Hero
  },
  data() {
    return{
      Image
      //pdfLink : require('../assets/pdf/ylc_strategy.pdf')

    }
  }
}
</script>